import { c as _c } from "react/compiler-runtime";
import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import { cx } from 'class-variance-authority';
import { forwardRef } from 'react';
import type { ItemProps } from '../dropdown.types';
type SubTriggerProps = Omit<ItemProps, 'variant'>;
const SubTrigger = forwardRef<HTMLDivElement, SubTriggerProps>((t0, ref) => {
  const $ = _c(32);
  let IconLeft;
  let IconRight;
  let children;
  let className;
  let destructive;
  let props;
  let t1;
  if ($[0] !== t0) {
    const {
      iconLeft: t2,
      iconRight: t3,
      children: t4,
      size: t5,
      destructive: t6,
      className: t7,
      asLink,
      checked,
      onSelect,
      shortcutHint,
      ...t8
    } = t0;
    IconLeft = t2;
    IconRight = t3;
    children = t4;
    t1 = t5;
    destructive = t6;
    className = t7;
    props = t8;
    $[0] = t0;
    $[1] = IconLeft;
    $[2] = IconRight;
    $[3] = children;
    $[4] = className;
    $[5] = destructive;
    $[6] = props;
    $[7] = t1;
  } else {
    IconLeft = $[1];
    IconRight = $[2];
    children = $[3];
    className = $[4];
    destructive = $[5];
    props = $[6];
    t1 = $[7];
  }
  const size = t1 === undefined ? "default" : t1;
  const t2 = !destructive;
  const t3 = size === "default";
  const t4 = size === "compact";
  const t5 = size === "tiny";
  let t6;
  if ($[8] !== className || $[9] !== destructive || $[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = cx("relative flex w-full overflow-hidden cursor-pointer rounded-default bg-elevated gap-3 box-border items-center justify-between", "data-[disabled]:text-quaternary data-[disabled]:cursor-auto data-[disabled]:select-none data-[disabled]:hover:bg-transparent", "data-[state=open]:bg-(--dropdown-hover-bg)", "focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-primary", "focus:outline-none", {
      "hover:bg-(--dropdown-hover-bg) text-primary": t2,
      "hover:bg-error text-error": destructive,
      "px-3 py-2 text-body-2 h-9": t3,
      "px-3 py-2 text-body-2 h-8": t4,
      "px-3 py-1 text-caption-2 h-7": t5
    }, className);
    $[8] = className;
    $[9] = destructive;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const sharedStyles = t6;
  let t7;
  if ($[15] !== IconLeft || $[16] !== destructive) {
    t7 = IconLeft && <IconLeft color={destructive ? "error" : undefined} />;
    $[15] = IconLeft;
    $[16] = destructive;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== children) {
    t8 = <div className="flex items-center w-full truncate text-decoration-none">{children}</div>;
    $[18] = children;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== IconRight || $[21] !== destructive) {
    t9 = IconRight && <IconRight className="ml-auto" color={destructive ? "error" : undefined} />;
    $[20] = IconRight;
    $[21] = destructive;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== ref || $[24] !== sharedStyles || $[25] !== t7 || $[26] !== t8 || $[27] !== t9) {
    t10 = <div ref={ref} className={sharedStyles}>{t7}{t8}{t9}</div>;
    $[23] = ref;
    $[24] = sharedStyles;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== props || $[30] !== t10) {
    t11 = <RadixDropdown.SubTrigger {...props} asChild={true}>{t10}</RadixDropdown.SubTrigger>;
    $[29] = props;
    $[30] = t10;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
});
export default SubTrigger;